import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

function CrossStreet({
  errorMessage,
  fieldName,
  label,
  require = false,
  requiredPlaceholder,
}: {
  errorMessage?: string;
  fieldName: string;
  label: string;
  require?: boolean;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  let fieldValidations = {};
  if (require) fieldValidations = { required: errorMessage };

  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          className="w-full"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={require}
          requiredPlaceholder={requiredPlaceholder}
          value={value}
        />
      )}
      fieldName={fieldName}
      fieldValidations={fieldValidations}
      label={label}
    />
  );
}

export default CrossStreet;
